import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-duration-timer',
  standalone: false,
  templateUrl: './duration-timer.component.html',
  styleUrl: './duration-timer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DurationTimerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() progress: number = 0;
  @Input() itemsLength: number = 0;
  @Input() currentIndex: number = 0;

  @Input() workDuration: number | null = 0;
  @Output() workDurationChange = new EventEmitter<number>();

  private timerId: any = null;
  isPaused = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['workDuration'] && !changes['workDuration'].isFirstChange()) {
      this.ensureNumericDuration();
      this.cdr.markForCheck();
    }
  }

  ngOnInit(): void {
    this.ensureNumericDuration();
    this.startTimer();
  }

  private ensureNumericDuration(): void {
    if (this.workDuration == null || isNaN(Number(this.workDuration))) {
      this.workDuration = 0;
    } else {
      this.workDuration = Number(this.workDuration);
    }
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  /** Start / Resume timer */
  private startTimer(): void {
    if (this.timerId) return;

    this.isPaused = false;

    this.timerId = setInterval(() => {
      if (this.workDuration === null || isNaN(this.workDuration)) {
        this.workDuration = 0;
      }
      this.workDuration++;
      this.workDurationChange.emit(this.workDuration);
      this.cdr.markForCheck();
    }, 1000);
  }

  /** Pause timer */
  private stopTimer(): void {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
    this.isPaused = true;
  }

  /** Toggle pause/resume */
  toggleTimer(): void {
    this.isPaused ? this.startTimer() : this.stopTimer();
  }

  /** Time formatter (HH:mm:ss) */
  formatTime(seconds: any): string {
    const totalSeconds = Number(seconds);
    if (isNaN(totalSeconds) || totalSeconds < 0) return '00:00:00';

    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = Math.floor(totalSeconds % 60);

    return `${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`;
  }

  private pad(num: number): string {
    return num < 10 ? `0${num}` : num.toString();
  }
}
